// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ Helpers
const { formatText, getLanguage } = require('core/i18n').i18n;

// @components
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { LabelDate } = require('commonsComponents/labelDate');
const { OKLink } = require('commonsComponents/OKLink');

// @constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const { HYPHEN, REFERRAL_STATUS_PENDING, REFERRAL_STATUS_ACCOMPLISHED } = require('constants/index');


class ReferralsTableRow extends React.Component {
    render() {
        const { immTransaction, id } = this.props;
        const immReferral = immTransaction;
        const status = (immReferral.get('status')).toUpperCase();
        
        let statusText;
        let getReferralAmount = HYPHEN;
        switch(status) {
            case REFERRAL_STATUS_PENDING:
                statusText = formatText('referrals-statusPending');
                break;
            case REFERRAL_STATUS_ACCOMPLISHED:
                statusText = formatText('referrals-statusAccomplished');
                getReferralAmount = immReferral.get('gift');
                break;
            default:
                statusText = formatText('referrals-statusUtilized')
        }

        const promotionLink = !!immReferral.get('promotionUrl') ? (
            <OKLink
                modifier="emphasize"
                target="_blank"
                to={immReferral.get('promotionUrl')}
            >
                {immReferral.get('promotionName')}
            </OKLink>
        ) : immReferral.get('promotionName');
        return (
            <OKTableRow key={id}>
                <OKTableCell>
                    <LabelDate
                        date={immReferral.get('invitationDate')}
                        language={getLanguage()}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell>
                    {promotionLink}
                </OKTableCell>
                <OKTableCell>
                    {immReferral.get('giftType') || HYPHEN}
                </OKTableCell>
                <OKTableCell>
                    {immReferral.get('invitationCode')}
                </OKTableCell>
                <OKTableCell>
                    {statusText}
                </OKTableCell>
                <OKTableCell>
                    {getReferralAmount}
                </OKTableCell>
            </OKTableRow>
        );
    }
}

ReferralsTableRow.propTypes = {
    immTransaction: PropTypes.object.isRequired, // This prop should named immReferral but there is a limitation with LastMovementsTable
    id: PropTypes.string.isRequired
};

ReferralsTableRow.defaultProps = {
    className: ''
};

module.exports = ReferralsTableRow;
